module.exports = __webpack_public_path__ + "img/france-pneumonia-female.4cb214f3.png";